module.exports = __webpack_public_path__ + "static/media/HomeBanner.454201eb.jpg";